import Snackbar from '@luminopia/react-toolbox/lib/snackbar'
import 'babel-polyfill'
import 'core/sentry'

import PrivateRoute from 'core/components/PrivateRoute'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {connect, Dispatch, Provider} from 'react-redux'
import {Route, RouteComponentProps, Router, Switch} from 'react-router'
import Dashboard from './components/dashboard/dashboard'
import history from './history'
import * as classNames from './main.css'
import * as Pages from './pages'
import * as routes from './routes'
import store, {extendTokenRequest, listenHeartbeatRequest, snackbarReset} from './store'
import {IState} from './store/reducer'

interface IStateProps {
  isLoggedIn: boolean
  isHydrated: boolean
  snackbarIsActive: boolean
  snackbarLabel: string
}

interface IDispatchProps {
  onClickSnackbar: () => void
  onUserAction: () => void
  onMount: () => void
}

interface IOwnProps {
}

interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

class Main extends React.PureComponent<IProps, {}> {
  private removeSubscriptions: Array<() => void> = []

  public componentDidMount() {
    this.props.onMount()
    // User action defined as any mouse click
    window.addEventListener('mousedown', this.props.onUserAction)
    const clearListener = () => window.removeEventListener('mousedown', this.props.onUserAction)
    this.removeSubscriptions.push(clearListener)
  }

  public componentWillUnmount() {
    this.removeSubscriptions.forEach((removeFn) => removeFn())
  }

  public render(): React.ReactElement<{}> {
    const { isLoggedIn, isHydrated } = this.props

    if (!isHydrated) {
      return <div></div>
    }

    // TODO Snackbar I18N
    return (
      <Router history={history}>
        <div className={classNames.main}>
          <Switch>
            <Route path={routes.loginRoute()} component={Pages.LoginPage} />
            <Route path={routes.logoutRoute()} component={Pages.LogoutPage} />
            <PrivateRoute
              path={routes.rootRoute()}
              isAccessible={isLoggedIn}
              redirectTo={routes.loginRoute()}
              redirectState={(routeProps: RouteComponentProps<void>) => ({ from: routeProps.location })}
              render={(props) => (
                <Dashboard {...props}>
                  <Route exact path={routes.rootRoute()} render={() => <Pages.SubjectsListPage />} />
                  <Route exact path={routes.subjectCreateRoute()} component={Pages.SubjectCreatePage} />
                  <Route exact path={routes.subjectConfirmRoute()} component={Pages.SubjectConfirmPage} />
                  <Route exact path={routes.subjectShowRoute()} component={Pages.SubjectPage} />
                  <Route exact path={routes.prescriptionCreateRoute()} component={Pages.CreatePrescriptionPage} />
                  <Route exact path={routes.prescriptionUpdateRoute()} component={Pages.UpdatePrescriptionPage} />
                </Dashboard>
              )}
            />
          </Switch>

          <Snackbar
            action='Dismiss'
            onClick={this.props.onClickSnackbar}
            active={this.props.snackbarIsActive}
            label={this.props.snackbarLabel}
            type='cancel'
          />
        </div>
      </Router>
    )
  }
}

const mapStateToProps = (state: IState) => ({
  isLoggedIn: !!state.login.token,
  isHydrated: state.persist.isHydrated,
  snackbarIsActive: state.main.snackbar.isActive,
  snackbarLabel: state.main.snackbar.label,
})
const mapDispatchToProps = (dispatch: Dispatch<void>) =>  ({
  onClickSnackbar: () => dispatch(snackbarReset()),
  onUserAction: () => dispatch(extendTokenRequest()),
  onMount: () => dispatch(listenHeartbeatRequest()),
})
const ConnectedMain = connect<IStateProps, IDispatchProps, {}, IState>(mapStateToProps, mapDispatchToProps)(Main)

ReactDOM.render(
  <Provider store={store}>
    <ConnectedMain />
  </Provider>,
  document.getElementById('app'),
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/main.tsx